import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import OnboardingGuide from './pages/OnboardingGuide';
import FillyOnIris from './pages/FillyOnIris';
import TaskPrioritization from './pages/TaskPrioritization';
import Organization from './pages/Organization';
import RoadmapAnalytics from './pages/RoadmapAnalytics';
import Dashboard from './pages/Dashboard';
import StakeholderRoadmap from './pages/StakeholderRoadmap';

import { AsanaTask } from './services/asanaService';

// Authentication enabled - using AuthenticationController for automatic auth
import { AuthenticationController } from './auth';

function App() {
  const [tasks, setTasks] = useState<AsanaTask[]>([]);

  return (
    <div className="App">
      <AuthenticationController>
        <Router>
          <Routes>
            {/* Home — org cards grid */}
            <Route path="/" element={<HomePage />} />
            <Route path="/onboarding" element={<OnboardingGuide />} />

            {/* Org-scoped routes — chatbot is the default landing for an org */}
            <Route path="/org/:orgId" element={<FillyOnIris />} />
            <Route path="/org/:orgId/chat" element={<FillyOnIris />} />
            <Route path="/org/:orgId/chat/:portfolioId" element={<FillyOnIris />} />
            <Route path="/org/:orgId/tasks/:portfolioId?" element={
              <TaskPrioritization onTasksLoaded={setTasks} />
            } />
            <Route path="/org/:orgId/hub" element={<Dashboard />} />
            <Route path="/org/:orgId/roadmap/:portfolioId?" element={<StakeholderRoadmap />} />
            <Route path="/org/:orgId/settings" element={<Organization />} />
            <Route path="/org/:orgId/analytics/:portfolioId?" element={
              <RoadmapAnalytics tasks={tasks} />
            } />

            {/* Legacy routes — redirect to new structure */}
            <Route path="/chat" element={<Navigate to="/" replace />} />
            <Route path="/chat/:orgId" element={<LegacyChatRedirect />} />
            <Route path="/admin/product" element={<Navigate to="/" replace />} />
            <Route path="/admin/product/:orgId/:portfolioId?" element={<LegacyAdminRedirect />} />
            <Route path="/admin/organization" element={<Navigate to="/" replace />} />
            <Route path="/admin/organization/:orgId" element={<LegacyOrgRedirect />} />
            <Route path="/roadmap/:orgId" element={<LegacyRoadmapRedirect />} />
          </Routes>
        </Router>
      </AuthenticationController>
    </div>
  );
}

/** Helper components for legacy route redirects */
function LegacyChatRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`/org/${orgId}/chat`} replace />;
}

function LegacyAdminRedirect() {
  const { orgId, portfolioId } = useParams();
  const target = portfolioId ? `/org/${orgId}/tasks/${portfolioId}` : `/org/${orgId}/tasks`;
  return <Navigate to={target} replace />;
}

function LegacyOrgRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`/org/${orgId}/settings`} replace />;
}

function LegacyRoadmapRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`/org/${orgId}/roadmap`} replace />;
}

export default App;